import * as yup from "yup";
import { cloneDeep } from "lodash";
import Cookies from "js-cookie";

import { getTimestamp } from "../../utils/lib";
// import { is } from "date-fns/locale";

const getUberId = ({ isAuth }) => {
	if (isAuth && Cookies.get("cl-uber")) {
		return Cookies.get("cl-uber");
	}
	return null;
};

// Validation
const usPhoneRegEx = /1\s\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}/;
const zipRegEx = /^[0-9]{5}$/;
const zipCodesEx = /^(9[0-5][0-9]{3}|960[0-9]{2}|961[0-8][0-9]|9619[0-9])$/;

export const validationSchema = yup
	.object()
	.shape({
		firstName: yup
			.string()
			.min(2, "First name should be at least 2 characters in length")
			.required("Please enter your first name"),
		lastName: yup
			.string()
			.min(2, "Last name should be at least 2 characters in length")
			.required("Please enter your last name"),
		address1OnFile: yup
			.string()
			.min(5, "Please enter your street address")
			.required("Please enter your street address on file"),
		cityOnFile: yup
			.string()
			.min(2, "Please enter your city")
			.required("Please enter your city on file"),
		stateOnFile: yup.string().required("Please select a state on file"),
		zipOnFile: yup
			.string()
			.matches(zipRegEx, "Zip Code must be 5 digits")
			.required("Please enter your 5-digit zip code on file"),
		zip: yup.string().when(["stateOnFile", "zipOnFile"], {
			is: (a, b) => (a !== "CA" || !zipCodesEx.test(b)) && zipRegEx.test(b),
			then: yup
				.string()
				.min(5, "Please enter zip code")
				.test("zip_code", "Please enter a California Zip Code", (value) => {
					const validateZip = zipCodesEx.test(value) ? true : false;
					return validateZip;
				})
				.required("Please enter your Zip Code"),
		}),
		state: yup.string().when(["stateOnFile", "zipOnFile"], {
			is: (a, b) => (a !== "CA" || !zipCodesEx.test(b)) && zipRegEx.test(b),
			then: yup
				.string()
				.test(
					"validate_state",
					"Must be California state to submit the form",
					(value) => {
						const validateZip = value === "CA" ? true : false;
						return validateZip;
					}
				)
				.required("Please select your current state"),
		}),
		phoneOnFile: yup
			.string()
			.matches(usPhoneRegEx, "Please enter a valid phone number on file")
			.required("Please enter your phone number on file"),
		phone: yup
			.string()
			.nullable()
			.notRequired()
			.matches(
				usPhoneRegEx,
				"Please enter a valid current phone number on file"
			),
		emailOnFile: yup
			.string()
			.email("Please enter a valid email address")
			.required("Please enter a valid email address on file"),

		address1: yup.string().when(["stateOnFile", "zipOnFile"], {
			is: (a, b) => (a !== "CA" || !zipCodesEx.test(b)) && zipRegEx.test(b),
			then: yup
				.string()
				.min(5, "Please enter your street address")
				.required("Please enter your street address"),
		}),
		city: yup.string().when(["stateOnFile", "zipOnFile"], {
			is: (a, b) => (a !== "CA" || !zipCodesEx.test(b)) && zipRegEx.test(b),
			then: yup
				.string()
				.min(5, "Please enter your current city address")
				.required("Please enter your current city address"),
		}),
		email: yup
			.string()
			.email("Please enter a valid email address")
			.notRequired("Please enter a valid email address on file"),
		requestAccess: yup.boolean(),
		requestDelete: yup.boolean(),
		requestCorrection: yup.boolean(),
		trpCcr: yup.object().shape({
			isCcr: yup.boolean(),
			firstName: yup.string().when("isCcr", {
				is: true,
				then: yup
					.string()
					.min(2, "Please enter your first name")
					.required("Please enter your first name"),
			}),
			lastName: yup.string().when("isCcr", {
				is: true,
				then: yup
					.string()
					.min(2, "Please enter your last name")
					.required("Please enter your last name"),
			}),
			callCenter: yup.string().when("isCcr", {
				is: true,
				then: yup
					.string()
					.oneOf(
						["II Call Center", "529 Call Center", "Help Desk", "RPS CAM or RM"],
						"Please select the relevant group you work for"
					)
					.required("Please select the relevant group you work for"),
			}),
			rpsPlanID: yup.string().when("callCenter", {
				is: "RPS CAM or RM",
				then: yup
					.string()
					.min(1, "Please enter plan ID")
					.required("Please enter plan ID"),
			}),
			rpsPlanName: yup.string().when("callCenter", {
				is: "RPS CAM or RM",
				then: yup
					.string()
					.min(1, "Please enter plan Name")
					.required("Please enter plan Name"),
			}),
			last4SSN: yup.string().when("callCenter", {
				is: "RPS CAM or RM",
				then: yup
					.string()
					.min(4, "Please enter the last 4 digits of SSN")
					.required("Please enter the last 4 digits of SSN"),
			}),
			rpsMarket: yup.string().when("callCenter", {
				is: "RPS CAM or RM",
				then: yup
					.string()
					.notRequired("Please select the market group you work for"),
			}),
			authenticated: yup.boolean().when("isCcr", {
				is: true,
				then: yup
					.boolean()
					.required(
						"Please indicate if the the requester has been authenticated"
					),
			}),
			rpsPlanSponsor: yup.boolean(),
		}),
	})
	.test("testRequestCheckboxes", null, (obj) => {
		if (obj.requestAccess || obj.requestDelete || obj.requestCorrection) {
			return true;
		}

		return new yup.ValidationError(
			"Please select at least one request option",
			null,
			"requestChecked"
		);
	})

	.test("testRelationship check box", null, (obj) => {
		if (
			obj.trpRel.ii ||
			obj.trpRel.b2b1 ||
			obj.trpRel.b2b2 ||
			obj.trpRel.b2b3 ||
			obj.trpRel.dir ||
			obj.trpRel.employee ||
			obj.trpRel.job ||
			obj.trpRel.contractor ||
			obj.trpRel.na
		) {
			console.log("found relation ship object");
			return true;
		}
		return new yup.ValidationError(
			"Please select at least one request option",
			null,
			"trpRelChecked"
		);
	});

export const defaultValues = {
	firstName: "",
	middleName: "",
	lastName: "",
	suffix: "",
	address1OnFile: "",
	address2OnFile: "",
	cityOnFile: "",
	stateOnFile: "",
	zipOnFile: "",
	emailOnFile: "",
	phoneOnFile: "",
	address1: "",
	address2: "",
	city: "",
	state: "",
	zip: "",
	email: "",
	phone: "",
	requestAccess: false,
	requestDelete: false,
	requestCorrection: false,
	companyName: "",
	companyOnFile: "",
	company: "",
	trpRel: {
		ii: false,
		b2b1: false,
		b2b2: false,
		b2b3: false,
		dir: false,
		employee: false,
		job: false,
		contractor: false,
		na: false,
	},
	trpCcr: {
		isCcr: false,
		firstName: "",
		lastName: "",
		callCenter: "",
		authenticated: undefined,
		rpsPlanID: "",
		rpsPlanName: "",
		rpsMarket: "",
		last4SSN: "",
		rpsPlanSponsor: false,
	},
};

export const cleanFields = ({ values, isAuth, userId }) => {
	const req = cloneDeep(values);
	let allowSave = false;

	// add values to the request
	req.requestId = Math.ceil(Math.random() * 1e16).toString(36);
	req.uberId = getUberId({ isAuth });
	req.requestDateTime = getTimestamp();
	req.authenticated = typeof isAuth === "boolean" ? isAuth : false;

	// if !trpCcr.isCcr clear the field values of trpCcr before sending
	if (!req.trpCcr.isCcr) {
		req.trpCcr = null;
	} else {
		delete req.trpCcr.isCcr;
		req.trpCcr.userId = typeof userId === "string" ? userId : "";
	}

	// test honey pot value and set to true to pass swagger validation
	if (req.companyName.length === 0) {
		req.companyName = true;
		allowSave = true;
	}

	let jsnStr = JSON.stringify(
		req,
		function (k, v) {
			if (v === "") {
				return null;
			} else if (typeof v === "string") {
				return v.trim();
			}

			return v;
		},
		2
	);

	return { data: jsnStr, allowSave };
};

export const stateOptions = [
	{ value: "", label: "" },
	{ value: "AL", label: "Alabama" },
	{ value: "AK", label: "Alaska" },
	{ value: "AZ", label: "Arizona" },
	{ value: "AR", label: "Arkansas" },
	{ value: "CA", label: "California" },
	{ value: "CO", label: "Colorado" },
	{ value: "CT", label: "Connecticut" },
	{ value: "DE", label: "Delaware" },
	{ value: "DC", label: "District Of Columbia" },
	{ value: "FL", label: "Florida" },
	{ value: "GA", label: "Georgia" },
	{ value: "HI", label: "Hawaii" },
	{ value: "ID", label: "Idaho" },
	{ value: "IL", label: "Illinois" },
	{ value: "IN", label: "Indiana" },
	{ value: "IA", label: "Iowa" },
	{ value: "KS", label: "Kansas" },
	{ value: "KY", label: "Kentucky" },
	{ value: "LA", label: "Louisiana" },
	{ value: "ME", label: "Maine" },
	{ value: "MD", label: "Maryland" },
	{ value: "MA", label: "Massachusetts" },
	{ value: "MI", label: "Michigan" },
	{ value: "MN", label: "Minnesota" },
	{ value: "MS", label: "Mississippi" },
	{ value: "MO", label: "Missouri" },
	{ value: "MT", label: "Montana" },
	{ value: "NE", label: "Nebraska" },
	{ value: "NV", label: "Nevada" },
	{ value: "NH", label: "New Hampshire" },
	{ value: "NJ", label: "New Jersey" },
	{ value: "NM", label: "New Mexico" },
	{ value: "NY", label: "New York" },
	{ value: "NC", label: "North Carolina" },
	{ value: "ND", label: "North Dakota" },
	{ value: "OH", label: "Ohio" },
	{ value: "OK", label: "Oklahoma" },
	{ value: "OR", label: "Oregon" },
	{ value: "PA", label: "Pennsylvania" },
	{ value: "RI", label: "Rhode Island" },
	{ value: "SC", label: "South Carolina" },
	{ value: "SD", label: "South Dakota" },
	{ value: "TN", label: "Tennessee" },
	{ value: "TX", label: "Texas" },
	{ value: "UT", label: "Utah" },
	{ value: "VT", label: "Vermont" },
	{ value: "VA", label: "Virginia" },
	{ value: "WA", label: "Washington" },
	{ value: "WV", label: "West Virginia" },
	{ value: "WI", label: "Wisconsin" },
	{ value: "WY", label: "Wyoming" },
];
